export default __webpack_public_path__ + "static/media/Ubuntu-Light.0dd2d598.ttf";